module.exports = __webpack_public_path__ + "static/media/shipping.b488d1ba.svg";